/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import Configuration from "./base/configuration";
import ConfigureComparision from "./base/configure-comparison";
import ConfigureLimit from "./base/configure-limit";
import ConfigureSort from "./base/configure-sort";
import ConfigurePoints from "./base/configure-points";
import ConfigureHideLegend from "./base/configure-hide-legend";
import ConfigureLabelAngle from "./base/configure-label-angle";

const LineChartConfiguration = (props) => {
  return (
    <Configuration title="Configure line chart">
      <ConfigureLimit />
      <ConfigureSort />
      <ConfigureLabelAngle />
      <ConfigureComparision />
      <ConfigurePoints />
      <ConfigureHideLegend />
    </Configuration>
  );
};

export default LineChartConfiguration;
